(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artie-judgeme-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-artie-jm]');
    roots.forEach(function (root) {
      var track = root.querySelector('[data-artie-jm-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-artie-jm-card]'));
      var prev = root.querySelector('[data-artie-jm-prev]');
      var next = root.querySelector('[data-artie-jm-next]');
      var dotsWrap = root.querySelector('[data-artie-jm-dots]');
      if (!cards.length) return;

      function perView() {
        var cw = cards[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
        return Math.max(1, Math.round((track.clientWidth + gap) / (cw + gap)));
      }
      function pageCount() { return Math.max(1, Math.ceil(cards.length / perView())); }
      function currentPage() {
        var cw = cards[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
        var idx = Math.round(track.scrollLeft / (cw + gap));
        return Math.min(pageCount() - 1, Math.floor(idx / perView()));
      }
      function scrollToPage(p) {
        var cw = cards[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
        var target = Math.min(p, pageCount() - 1) * perView() * (cw + gap);
        track.scrollTo({ left: target, behavior: 'smooth' });
      }
      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        var n = pageCount();
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'artie-jm__dot';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Reviews page ' + (i + 1) + ' of ' + n);
          b.setAttribute('aria-selected', 'false');
          b.dataset.page = String(i);
          b.addEventListener('click', function (e) { scrollToPage(parseInt(e.currentTarget.dataset.page, 10)); });
          dotsWrap.appendChild(b);
        }
        sync();
      }
      function sync() {
        var p = currentPage();
        var n = pageCount();
        if (dotsWrap) {
          Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
            var on = i === p;
            d.classList.toggle('is-active', on);
            d.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        }
        if (prev) prev.disabled = p <= 0;
        if (next) next.disabled = p >= n - 1;
      }
      if (prev) prev.addEventListener('click', function () { scrollToPage(currentPage() - 1); });
      if (next) next.addEventListener('click', function () { scrollToPage(currentPage() + 1); });
      var raf = null;
      track.addEventListener('scroll', function () { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
      var rt = null;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(buildDots, 150); });
      buildDots();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artie-review-rotator"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-artie-review-rotator]').forEach(function (root) {
  var slides = root.querySelectorAll('[data-artie-review-slide]');
  var dots = root.querySelectorAll('[data-artie-review-dot]');
  if (slides.length < 2) return;
  var index = 0;
  var intervalMs = (parseInt(root.dataset.interval, 10) || 7) * 1000;
  var timer = null;

  function show(next) {
    slides[index].classList.remove('is-active');
    if (dots[index]) { dots[index].classList.remove('is-active'); dots[index].setAttribute('aria-selected', 'false'); }
    index = (next + slides.length) % slides.length;
    slides[index].classList.add('is-active');
    if (dots[index]) { dots[index].classList.add('is-active'); dots[index].setAttribute('aria-selected', 'true'); }
  }
  function start() {
    stop();
    timer = setInterval(function () { show(index + 1); }, intervalMs);
  }
  function stop() {
    if (timer) clearInterval(timer);
    timer = null;
  }
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      show(i);
      start();
    });
  });
  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);
  start();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
